import { ChangeDetectionStrategy, Component } from '@angular/core';
import { DressfitPanelComponent } from '@pixacare/dressfit-angular';

// The panel fills whatever height it is given, and a dialog gives none of its own.
@Component({
  selector: 'pxc-dressfit-panel-dialog',
  templateUrl: './dressfit-panel-dialog.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [DressfitPanelComponent],
  host: { class: 'flex h-[75vh] flex-col' },
})
export class DressfitPanelDialogComponent {}
